import { setReferrer } from '../../lib/actions';
import { getSystemErrorMessaging } from '../../lib/side-effects/error';

import type { Dispatch } from '@avalara/types/actions';
import type { Config } from '../../../../types';

const changedFromSbxToProd = (referrer: string, conf: Config) => {
  if (window.appEnv !== 'prod') return false;

  const aaSbxUrl = new RegExp(new URL(conf.AA_SBX_URL || '').hostname);
  const cupSbxUrl = new RegExp(new URL(conf.CUP_SBX_URL || '').hostname);
  return aaSbxUrl.test(referrer) || cupSbxUrl.test(referrer);
};

export const redirectFromKnownReferrer = (dispatch: Dispatch, doc: Document, conf: Config) => {
  try {
    if (doc.referrer.length === 0) return;

    const referrer = new URL(doc.referrer).hostname;

    dispatch(setReferrer(doc.referrer));

    const fromSbx = changedFromSbxToProd(referrer, conf);

    if (fromSbx) {
      dispatch(getSystemErrorMessaging({ errorCode: 'redirectOutOfSandbox' }));
    }
  } catch {
    // do nothing
  }
};
